// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/deployment_metadata.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import { getNameParser } from "../../../../../runtime";
import type { HttpMethod } from "./http_method_pb";

/**
 * Represents the metadata of a deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeploymentMetadata
 */
export type DeploymentMetadata = {
/**
 * Resource name.
 *
 * @generated from field: string name = 1;
 */
name?: string;
/**
 * Provides access configuration for the deployed model's scoring capabilities.
 * Contains endpoint information for sending prediction requests and viewing example requests.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.ScoringInterface scoring_interface = 2;
 */
scoringInterface?: ScoringInterface;
}
;
export const deploymentMetadataName = getNameParser<'workspace' | 'deployment'>("workspaces/{workspace}/deployments/{deployment}/metadata");
/**
 * Defines available endpoints and API contract of a deployed scoring model.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ScoringInterface
 */
export type ScoringInterface = {
/**
 * This is the main scorer endpoint which computes model prediction from the given input data.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.ScoringEndpoint score = 1;
 */
score?: ScoringEndpoint;
/**
 * Returns a sample scoring request that can be sent to the `score` endpoint to generate
 * a prediction. This is useful for users to get an example request to test the `score` endpoint
 * with.
 *
 * NOTE: It is optional, but if left empty, the Model Management UI will not be able to display
 * the example `curl` command to the users.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.ScoringEndpoint sample_request = 2;
 */
sampleRequest?: ScoringEndpoint;
/**
 * The endpoint which responds with the capabilities supported by the scorer.  Clients should
 * call this endpoint to determine other endpoints the scorer has available.
 *
 * This endpoint was introduced in version 1.2.0 of the scorer API specification and may not be
 * implemented by older scorers.  Clients may interpret a non-implemented `capabilities` endpoint
 * as suggesting no additional capabilities are supported.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.ScoringEndpoint capabilities = 3;
 */
capabilities?: ScoringEndpoint;
}
;
/**
 * ScoringEndpoint defines the HTTP endpoint configuration used to invoke model scoring.
 * It specifies the URL and HTTP method required to send scoring requests to the deployed model.
 * Clients should use this information to construct proper API calls when requesting predictions.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ScoringEndpoint
 */
export type ScoringEndpoint = {
/**
 * POST endpoint URL of the deployment, typically in the form <ip/host>:<port>/<path>.
 * This is the empty string when the endpoint is not available.
 *
 * @generated from field: string uri = 1;
 */
uri?: string;
/**
 * HTTP method to use for this endpoint.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.HttpMethod method = 2;
 */
method?: HttpMethod;
}
;
